import Marquee from "react-fast-marquee";
import { TICKER } from "./content";

// Thin category ticker under the hero
export const CategoryTicker = () => (
  <div className="mt-20 border-y border-dm-ink/10 bg-white/60 py-4 backdrop-blur">
    <Marquee speed={40} gradient={false} autoFill>
      {TICKER.map((t, i) => (
        <span key={`${t}-${i}`} className="mx-6 flex items-center gap-6 text-sm font-bold uppercase tracking-[0.2em] text-dm-ink/70">
          {t}
          <span className="h-1.5 w-1.5 rounded-full bg-dm-guita" />
        </span>
      ))}
    </Marquee>
  </div>
);

// Big slow editorial marquee
export const EditorialMarquee = () => (
  <section className="overflow-hidden bg-dm-cream py-10 md:py-16">
    <Marquee speed={28} gradient={false} autoFill>
      <span className="mx-8 font-display text-[13vw] font-black leading-none tracking-tighter text-dm-ink md:text-[9vw]">
        MENOS TELA
      </span>
      <span className="mx-8 font-display text-[13vw] font-black leading-none tracking-tighter dm-outline md:text-[9vw]">
        MAIS MUNDO
      </span>
      <span className="mx-8 flex items-center font-display text-[13vw] leading-none md:text-[9vw]">
        <span className="dm-rainbow-text font-black tracking-tighter">DÓRÉMIGOS</span>
      </span>
    </Marquee>
  </section>
);
